/*
  Tohfa by Sonia — mobile menu.

  Full-screen overlay: open, close, Escape, scroll lock, focus returned to the
  burger on close. Vanilla JS, no dependencies, guarded so it is a no-op if the
  header markup is not on the page.
*/
(function () {
  var menu = document.getElementById('tohfa-mobile-menu');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');

  if (!menu || !openBtn) return;

  function setMenu(open) {
    menu.classList.toggle('open', open);
    menu.hidden = !open;
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);

    if (open) {
      var firstLink = menu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    } else {
      openBtn.focus();
    }
  }

  openBtn.addEventListener('click', function () {
    setMenu(true);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setMenu(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('open')) setMenu(false);
  });

  // Tapping a destination closes the overlay before the page swaps.
  menu.addEventListener('click', function (event) {
    if (event.target.closest('a')) setMenu(false);
  });

  // Desktop breakpoint takes over from the overlay — drop the scroll lock with it.
  var desktop = window.matchMedia('(min-width: 881px)');
  var onBreakpoint = function (event) {
    if (event.matches && menu.classList.contains('open')) setMenu(false);
  };

  if (desktop.addEventListener) {
    desktop.addEventListener('change', onBreakpoint);
  } else if (desktop.addListener) {
    desktop.addListener(onBreakpoint);
  }
})();
